import { Eye, Download, FileText } from "lucide-react";
import { Badge } from "@/components/ui/others/Badges";
import { Button } from "@/components/ui/button";

interface ChatFileAttachmentProps {
  file: {
    name: string;
    type: string;
  };
  mediaUrl?: string;
}

export function ChatFileAttachment({
  file,
  mediaUrl,
}: ChatFileAttachmentProps) {
  // Extract short extension from MIME type or filename
  const ext =
    file.name?.split(".").pop()?.toUpperCase() ||
    file.type?.split("/").pop()?.toUpperCase() ||
    "FILE";

  return (
    <div className="bg-[rgba(40,12,242,0.02)] border border-[rgba(40,12,242,0.06)] rounded-[12px] h-12 px-3 py-1.5 flex items-center gap-2 w-full">
      {/* File Icon */}
      <div className="relative size-8 shrink-0">
        <FileText className="size-8 text-[#cacfd8]" strokeWidth={1.5} />
        <Badge className="absolute bottom-0.5 left-0 bg-[#fb3748] !rounded-[3px] !px-1 !py-0.5 !text-white !text-[9px] !font-semibold uppercase !leading-tight tracking-tight !h-auto border-none">
          {ext}
        </Badge>
      </div>

      {/* File Name */}
      <div className="flex-1 min-w-0">
        <p className="text-[14px] font-medium text-[var(--colorblack-10)] tracking-[-0.56px] leading-normal truncate">
          {file.name}
        </p>
      </div>

      {/* Action Buttons */}
      <Button
        variant="ghost"
        size="icon"
        className="size-9 rounded-[12px]"
        onClick={() => mediaUrl && window.open(mediaUrl, "_blank")}
      >
        <Eye
          size={24}
          className="text-[var(--color-black-8)]"
          strokeWidth={1.5}
        />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="size-9 rounded-[12px]"
        onClick={() => {
          if (!mediaUrl) return;
          const a = document.createElement("a");
          a.href = mediaUrl;
          a.download = file.name;
          a.click();
        }}
      >
        <Download
          size={16}
          className="text-[var(--color-black-8)]"
          strokeWidth={2}
        />
      </Button>
    </div>
  );
}
